import React, { forwardRef } from 'react';
import styles from './ThreeDotsButton.scss.js';
import Icon from '../../../Icons/Icons/Icon/Icon.js';

const ThreeDotsButton = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    onClick
  } = _ref;
  return /*#__PURE__*/React.createElement("button", {
    onClick: onClick,
    "aria-label": "Open menu options",
    className: styles['dots-button'],
    ref: forwardedRef
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['dots-button__default-icon']
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "my-lessons-menu-dotted-small-default"
  })), /*#__PURE__*/React.createElement("div", {
    className: styles['dots-button__hover-icon']
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "my-lessons-menu-dotted-small-hover"
  })));
});
var ThreeDotsButton$1 = /*#__PURE__*/React.memo(ThreeDotsButton);

export { ThreeDotsButton$1 as default };
//# sourceMappingURL=ThreeDotsButton.js.map
